import { gql } from '@provision/graphql-client';

export const CONVERSATION_ASSIGNEE_GROUP_MANAGEMENT_FIELDS = gql`
  fragment ConversationAssigneeGroupManagementFields on ConversationAssigneeGroup {
    id
    conversationAssigneeGroupId
    partnerId
    name
    description
    icon
  }
`;
